<!-- <ngb-timepicker [(ngModel)]="time" [meridian]="meridian"></ngb-timepicker>
<button class="btn btn-sm btn-outline-{{meridian ? 'success' : 'danger'}}" (click)="toggleMeridian()">
    Meridian - {{meridian ? "ON" : "OFF"}}
</button>
<hr>
<pre>Selected time: {{time | json}}</pre> -->

<div class="example-wrapper">
	<kendo-timepicker
		[min]="model.min"
		[max]="model.max"
		[(ngModel)]="model.value"
		(ngModelChange)="onTimeChange($event)"
		#dateModel="ngModel"
		[disabled]="model.disabled"
		[readonly]="model.readonly"
		[placeholder]="model.placeholder"
		(blur)="onClick()"
		onkeydown="return false;"
	></kendo-timepicker>
</div>
<p class="error-msg" *ngIf="(model.required && model.displayError && !model.value)">{{ model.errorMessage}}</p>
